<template>
  <div class="br-estimate__context">
    <h1>All-in-one networking software for crafting valuable engagement among your employees, leaders, and teams.</h1>
    <p>You’ll be surprised how easy it is to set up, and how quickly you start seeing results!</p>
    <div class="br-estimate__value">
      <div class="text-group">
        <span class="text">{{ getWholeNumber }}</span>
        <span class="text text--muted">.{{ getDecimal }}</span>
      </div>
      <span class="text">per person monthly</span>
    </div>
    <div class="button-group">
      <button
        v-tippy="{
          arrow : true,
          arrowType : 'sharp',
          placement : 'top',
          animation : 'shift-away',
          maxWidth : 200
        }"
        content="Craft tailored 1-on-1 introductions amongst your employees."
        :class="{ 'button--active' : $store.getters['pricing/activeFeature'].indexOf('introductions') >= 0 }"
        class="button button--pill"
        @click.prevent="setFeature('introductions')">
        <span class="button__icon">
          <i class="icon icon-privacy-policy"/>
        </span>
        <span class="button__label">AI Introductions</span>
      </button>
      <button
        v-tippy="{
          arrow : true,
          arrowType : 'sharp',
          placement : 'top',
          animation : 'shift-away',
          maxWidth : 200
        }"
        content="Promote collaboration by strategically introducing groups of employees."
        :class="{ 'button--active' : $store.getters['pricing/activeFeature'].indexOf('collaboration') >= 0 }"
        class="button button--pill"
        @click.prevent="setFeature('collaboration')">
        <span class="button__icon">
          <i class="icon icon-networking"/>
        </span>
        <span class="button__label">AI Collaboration</span>
      </button>
      <button
        v-tippy="{
          arrow : true,
          arrowType : 'sharp',
          placement : 'top',
          animation : 'shift-away',
          maxWidth : 200
        }"
        content="Host public and private discussion groups and communities for employees."
        :class="{ 'button--active' : $store.getters['pricing/activeFeature'].indexOf('communities') >= 0 }"
        class="button button--pill"
        @click.prevent="setFeature('communities')">
        <span class="button__icon">
          <i class="icon icon-a-chat"/>
        </span>
        <span class="button__label">AI Communities</span>
      </button>
    </div>
    <a
      href="/products"
      class="button button--link">
      <span class="button__text">Learn more about our products</span>
      <span class="button__icon">
        <i class="icon icon-arrow-right-2"/>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    getWholeNumber () {
      return (this.$store.getters['pricing/getTotalPrice'] + '').split('.')[0]
    },
    getDecimal () {
      let value = (this.$store.getters['pricing/getTotalPrice'] + '').split('.')[1]

      if (value && value.length > 2) {
        value = value.slice(0, 1)
      }

      return String(value || 0).padEnd(2, '0')
    }
  },
  methods: {
    setFeature (feature) {
      this.$store.dispatch('pricing/setFeature', feature)
    }
  }
}
</script>
